import api from './api';

// --- User's Dynamic Menu ---
export const getUserMenuV2 = () => api.get('menu/v2');

// --- Menu Management (CRUD) ---
export const getAllMenus = () => api.get('menus');
export const getMenuById = (id: string) => api.get(`menus/${id}`);
export const createMenu = (menuData: any) => api.post('menus', menuData);
export const updateMenu = (id: string, menuData: any) => api.put(`menus/${id}`, menuData);
export const deleteMenu = (id: string) => api.delete(`menus/${id}`);
